import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import HttpUtility from "../../utilities/HttpUtility";
import { AxiosResponse } from "axios";
import EffectUtility from "../../utilities/EffectUtility";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import UserLoginRequestModel from "./models/UserLoginRequestModel";
import UserRegistrationRequestModel from "./models/UserRegistrationRequestModel";
import UserRegistrationConfirmRequestModel from "./models/UserRegistrationConfirmRequestModel";
import UserInfoModel from "./models/UserInfoModel";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";
import RecuperoPasswordRequestModel from "./models/RecuperoPasswordRequestModel";
import CambioPasswordRequestModel from "./models/CambioPasswordRequestModel";
import UserRegistrationRinvioMail from "./models/UserRegistrationRinvioMail";
//import RegistrationAnonyousModel from "./models/RegistrationAnonymousModel";

export default class UserEffect {
    public static async requestUserLogin(
        userLogin: UserLoginRequestModel
    ): Promise<ResponseAuthTokensModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.login;
        return EffectUtility.postToModel<ResponseAuthTokensModel>(ResponseAuthTokensModel, endpoint, userLogin);
    }

    public static async requestUserRegistration(
        userRegistration: UserRegistrationRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.registrazione;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, userRegistration);
    }

    public static async requestVerificaToken(token: string): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.verificaToken;
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { token: token });
    }

    public static async requestUserRegistrationConfirm(
        userRegistrationConfirm: UserRegistrationConfirmRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.confermaRegistrazione;
        return EffectUtility.putToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, userRegistrationConfirm);
    }

    public static async requestGetInfoUtente(user: UserInfoModel): Promise<UserInfoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getInfoUtente;
        return EffectUtility.getToModel<UserInfoModel>(UserInfoModel, endpoint, user);
    }

    public static async requestUserDelete(): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.deleteUtente;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint);
    }

    public static async requestUserRecuperoPassword(
        user: RecuperoPasswordRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.credenzialiRecuperoCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, user);
    }

    public static async requestUserVerificaTokenRecuperoPassword(
        token: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.credenzialiVerificaTokenCQSonline;
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { token: token });
    }

    public static async requestUserCambioPassword(
        user: CambioPasswordRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.credenzialiAggiornaCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, user);
    }

    public static async requestUserRinvioEmail(
        userRegistration: UserRegistrationRinvioMail
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.rinvioEmailRegistrazioneCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, userRegistration);
    }

    public static async requesSaveConsesiUtenteConfirm(
        consensi: UserRegistrationRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        console.log("effect");
        const endpoint: string = environment.api.saveConsesiPrivacyUtente;
        console.log("effect");
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, consensi);
    }

    /**
     * This is only to trigger an error api response so we can use it for an example in the AboutPage
     */
    public static async requestError(): Promise<any | HttpErrorResponseModel> {
        const endpoint: string = environment.api.errorExample;
        const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.get(endpoint);

        if (response instanceof HttpErrorResponseModel) {
            return response;
        }
        return response.data;
    }
}
